//https://boost.allnetru.dev/api/documentation#/Countries
import { createApi } from '@reduxjs/toolkit/query/react';
import { GetFiltersResponse } from './models';
import { baseQueryWithReauth } from '../baseQueryWithReauth';

const countries = `countries`;

export const countriesApi = createApi({
  reducerPath: countries,
  baseQuery: baseQueryWithReauth,
  tagTypes: [countries],
  endpoints: (build) => ({
    getCountriesBySearch: build.query<
      GetFiltersResponse,
      { search: string; page?: number; with_payment_info?: string }
    >({
      query: ({ search, page, with_payment_info }) => {
        const params = new URLSearchParams();

        if (search && !(search.length > 0 && search.length < 2)) {
          params.append('search', search.toString());
        }
        if (page) {
          params.append('page', page.toString());
        }
        if (with_payment_info) {
          params.append('with_payment_info', with_payment_info.toString());
        }
        const queryString = params.toString();

        return {
          url: `/countries/filter/${queryString ? '?' + queryString : ''}`,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
    }),
  }),
});

export const { useGetCountriesBySearchQuery, useLazyGetCountriesBySearchQuery } = countriesApi;
